/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_LinkInputs */

const en_pol_link = /** @type {(inputs: Pol_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI provider policy`)
};

const id_pol_link = /** @type {(inputs: Pol_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan penyedia AI`)
};

/**
* | output |
* | --- |
* | "AI provider policy" |
*
* @param {Pol_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_link = /** @type {((inputs?: Pol_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_link(inputs)
	return en_pol_link(inputs)
});